import React, { ComponentProps } from 'react';
import Typography from 'antd/es/typography';
import clsx from 'clsx';

import './OpTitle.scss';

const { Title } = Typography;

/**
 * OpTitle is a wrapper around Ant Design's Typography.Title component.
 * It displays heading text with semantic HTML heading levels (h1-h5).
 * 
 * Use this component for page titles, section headings, and any hierarchical text structure.
 * Provides consistent styling for headings throughout the application.
 * 
 * @example
 * <OpTitle level={1}>Page Title</OpTitle>
 * <OpTitle level={2}>Section Heading</OpTitle>
 * 
 */
export const OpTitle = ({
  className,
  children,
  ...titleProps
}: ComponentProps<typeof Title>) => {
  return (
    <Title className={clsx('op-title', className)} {...titleProps}>
      {children}
    </Title>
  );
};
